// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "13eadf46f8a017d4794b47a23b66243cb0ebb803",
  version: "1.123.3",
};
